import Auth from '../api/auth';
import appConfig from '../../shared/helpers/appConfig';

// Per-brand SimAI/AI Studio URL, keyed by account_source — mirrors
// helper/brandStripeConfig.js. Falls back to the single VUE_APP_SIM_APP_URL
// when the account's brand has no dedicated URL configured.
const BRAND_SIM_APP_URLS = {
  dahreply: 'VUE_APP_DAHREPLY_SIM_APP_URL',
  singabot: 'VUE_APP_SINGABOT_SIM_APP_URL',
};

export function getBrandSimAppUrl(accountSource) {
  const key = BRAND_SIM_APP_URLS[accountSource];
  return (key && appConfig(key)) || appConfig('VUE_APP_SIM_APP_URL');
}

/**
 * Builds an SSO hand-off URL into the external SimAI/MHub app. The callback
 * endpoint logs the user in and resolves their workspace from `account-id`
 * server-side, so no workspace ID is stored in Chatwoot.
 *
 * @param {Object} options
 * @param {string|number} options.accountId
 * @param {string} [options.accountSource] - the account's custom_attributes.account_source,
 *   used to pick the brand-specific SimAI/AI Studio domain.
 * @param {string} [options.redirectPath] - relative path (e.g. '/settings/secrets')
 *   the external app should land on after resolving the workspace. Requires
 *   the external app's callback endpoint to support the `redirect_path` param.
 * @returns {string|null} the SSO URL, or null if the app isn't configured or
 *   the user isn't authenticated.
 */
export function buildSimAppUrl({
  accountId,
  accountSource,
  redirectPath = '',
} = {}) {
  const simAppUrl = getBrandSimAppUrl(accountSource);
  if (!simAppUrl) return null;

  const authData = Auth.getAuthData();
  if (!authData) return null;

  const params = new URLSearchParams({
    'access-token': authData['access-token'] || '',
    'token-type': 'Bearer',
    client: authData['client'] || '',
    uid: authData['uid'] || '',
    'account-id': String(accountId),
  });
  if (redirectPath) {
    params.set('redirect_path', redirectPath);
  }

  return `${simAppUrl}/api/auth/external/callback?${params.toString()}`;
}
